var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCommunitySidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41602 20.7502C7.41602 19.4627 7.85406 18.1603 8.92391 17.444C10.207 16.585 11.7525 16.0835 13.416 16.0835C15.0795 16.0835 16.6251 16.585 17.9081 17.444C18.978 18.1603 19.416 19.4627 19.416 20.7502",
    stroke: "url(#paint0_linear_11586_36111)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4173 12.7502C15.2583 12.7502 16.7507 11.2578 16.7507 9.41683C16.7507 7.57588 15.2583 6.0835 13.4173 6.0835C11.5764 6.0835 10.084 7.57588 10.084 9.41683C10.084 11.2578 11.5764 12.7502 13.4173 12.7502Z",
    stroke: "url(#paint1_linear_11586_36111)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 9.4165C22.2301 9.4165 23.6053 9.91904 24.7465 10.7797C25.7139 11.5093 26.0833 12.7433 26.0833 13.9549V14.0832",
    stroke: "url(#paint2_linear_11586_36111)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7507 6.08333C22.2234 6.08333 23.4173 4.88943 23.4173 3.41667C23.4173 1.94391 22.2234 0.75 20.7507 0.75C19.2779 0.75 18.084 1.94391 18.084 3.41667C18.084 4.88943 19.2779 6.08333 20.7507 6.08333Z",
    stroke: "url(#paint3_linear_11586_36111)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08333 9.4165C4.60316 9.4165 3.22795 9.91904 2.08675 10.7797C1.11941 11.5093 0.75 12.7433 0.75 13.9549V14.0832",
    stroke: "url(#paint4_linear_11586_36111)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08268 6.08333C7.55544 6.08333 8.74935 4.88943 8.74935 3.41667C8.74935 1.94391 7.55544 0.75 6.08268 0.75C4.60992 0.75 3.41602 1.94391 3.41602 3.41667C3.41602 4.88943 4.60992 6.08333 6.08268 6.08333Z",
    stroke: "url(#paint5_linear_11586_36111)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11586_36111",
    x1: 10.3936,
    y1: 16.3636,
    x2: 11.5316,
    y2: 21.4322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11586_36111",
    x1: 11.7382,
    y1: 6.48362,
    x2: 15.0317,
    y2: 12.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11586_36111",
    x1: 22.0734,
    y1: 9.69659,
    x2: 24.2162,
    y2: 13.9382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11586_36111",
    x1: 19.4074,
    y1: 1.0701,
    x2: 22.0421,
    y2: 5.63364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11586_36111",
    x1: 2.07337,
    y1: 9.69659,
    x2: 4.21617,
    y2: 13.9382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11586_36111",
    x1: 4.73939,
    y1: 1.0701,
    x2: 7.37415,
    y2: 5.63364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCommunitySidebar);
export default __webpack_public_path__ + "static/media/ActiveCommunitySidebar.a63aa6b47779fddb000121ab3776b9f8.svg";
export { ForwardRef as ReactComponent };